import { SearchLocation } from '../base/SearchListing/SearchLocation';

export const Search = () => {
  return <SearchLocation />;
};
